export { Icon, type IconProps } from "./Icon";
